
export const formatDate = (dateString: string) => {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { 
      day: '2-digit', 
      month: 'short', 
      year: 'numeric' 
    });
  } catch (error) {
    return dateString;
  }
};

export const formatDuration = (days?: number) => {
  if (!days && days !== 0) return "Not specified";
  if (days === 1) return "1 day";
  return `${days} days`;
};
